
    import './styles.scoped.css';
    export default {
  "button-trigger": "awsui_button-trigger_18eso_wu39i_5",
  "arrow": "awsui_arrow_18eso_wu39i_5",
  "has-caret": "awsui_has-caret_18eso_wu39i_38",
  "placeholder": "awsui_placeholder_18eso_wu39i_41",
  "pressed": "awsui_pressed_18eso_wu39i_54",
  "disabled": "awsui_disabled_18eso_wu39i_57",
  "in-filtering-token": "awsui_in-filtering-token_18eso_wu39i_66",
  "read-only": "awsui_read-only_18eso_wu39i_72",
  "invalid": "awsui_invalid_18eso_wu39i_89"
};
  